import Meta from '@/components/common/Meta'

import TemporaryStorageSolutionsPage from '@/v2/components/pages/landing-pages/temporary-storage-solutions-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/temporary-storage-solutions-page'

interface TemporaryStorageSolutionsPageProps {}

const Page: React.FC<TemporaryStorageSolutionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.temporary_storage_solutions.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.temporary_storage_solutions?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.temporary_storage_solutions?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <TemporaryStorageSolutionsPage />
    </>
  )
}

export default Page
